export default __webpack_public_path__ + "static/media/[RGB] BOX2HELP-crna.b0ecdbe4.png";